import { render, staticRenderFns } from "./category_edit.vue?vue&type=template&id=99e01152&scoped=true&"
import script from "./category_edit.vue?vue&type=script&lang=js&"
export * from "./category_edit.vue?vue&type=script&lang=js&"
import style0 from "./category_edit.vue?vue&type=style&index=0&id=99e01152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e01152",
  null
  
)

export default component.exports